import React, { useEffect, useState } from "react";
import { Tooltip } from "primereact/tooltip";

import "../index.css"

import { numberConversion } from "../../../../utils";


const Product = (props) => {
    const { materialBrands, handleWishListChange, buyerWishList, selectedTaxCondition, handleViewProduct } = props
    const { product, cartItems, setCartItems, updateCartItems } = props
    const { eachProduct, relatedCartItem } = product

    const [isWishlisted, setIsWishlisted] = useState(false)

    const materialImage = eachProduct.materialImage?.length > 0 ? eachProduct.materialImage[0] : "https://procmart-tech.s3.ap-south-1.amazonaws.com/app-images/no_image_no_pg+(6).png"

    useEffect(() => {
        let relatedBuyerWishListedProduct = buyerWishList.find(eachBuyerWishList => eachBuyerWishList.buyerRateContractId === eachProduct.buyerRateContractId && eachBuyerWishList.statusId === 1)
        if (relatedBuyerWishListedProduct){
            setIsWishlisted(true)
        }else{
            setIsWishlisted(false)
        }
    }, [buyerWishList])

    const handleQuantityChange = (event, selectedItem) => {
        cartItems.map(eachCartItem => {
            if (eachCartItem.buyerRateContractId === selectedItem.buyerRateContractId) {
                eachCartItem.quantity = event.target.value
            }
        })
        setCartItems([...cartItems])
    }

    const toggleWishlist = () => {
        setIsWishlisted(!isWishlisted)
        handleWishListChange(eachProduct.buyerRateContractId)
    }

    function calculateDiscount(listPrice, unitPrice) {
        if (listPrice === 0) return 0
        const discount = ((listPrice - unitPrice) / listPrice) * 100
        return Math.round(discount)
    }

    let isListPriceVisible = false
    let discount = 0
    if(eachProduct.listPrice){
        if(eachProduct.listPrice > eachProduct.unitPrice){
            isListPriceVisible = true
            discount = calculateDiscount(eachProduct.listPrice, eachProduct.unitPrice)
        }
    }

    const relatedMaterialBrand = materialBrands.find(eachMaterialBrand => eachMaterialBrand.brandId === eachProduct.brandId)

    let isAddToCartDisabled = false
    let tooltipStr = ""
    if (selectedTaxCondition){
        if (selectedTaxCondition === "Non Tax Exempted"){
            if (eachProduct.isTaxExempted){
                isAddToCartDisabled = true
                tooltipStr = "Only Taxable products can be added."
            }
        }else {
            if (eachProduct.isTaxExempted === false){
                isAddToCartDisabled = true
                tooltipStr = "Only Tax Exempted products can be added."
            }
        }
    }

    return (
        <>
            <div className="flex buyer-portal-product-card-container">
                <div className="flex mt-4" style={{ paddingLeft: "12px", paddingRight: "12px" }}>
                    <div className="product-box-3 flex flex-column h-100 wow fadeInUp" data-wow-delay="0.3s">
                        <div className="product-header" style={{height: "130px"}}>
                            <div className="product-image" style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                <img src={materialImage} className="product-card-img" style={{maxHeight: "120px", width: "auto", maxWidth: "180px" }}  alt=""></img>
                                <ul className="product-option">
                                    <li style={{ cursor: 'pointer' }} onClick={() => { handleViewProduct(eachProduct.buyerRateContractId) }}>
                                        <Tooltip target="#target-view-icon" content="View" position="top" />
                                        <i className="fa fa-eye" id="target-view-icon"></i>
                                    </li>
                                    <li style={{ cursor: 'pointer' }} onClick={toggleWishlist}>
                                        <Tooltip target="#target-wish-icon" content='Wishlist' position="top" />
                                        <i className={` fa-heart ${isWishlisted ? 'fa-solid wishlist-icon' : 'fa-regular'}`} id="target-wish-icon"></i>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="product-footer flex flex-grow-1">
                            <div className="flex flex-column flex-grow-1 justify-content-between product-detail buyer-portal-card-content">
                                <div>
                                    <h5 className="mb-1 name" style={{textWrap: "wrap", lineHeight: "19px"}}>
                                        {eachProduct.companyProdName}
                                    </h5>
                                    <div className='product-specification' style={{ marginTop: '0px' }}>
                                        <div className={`span-name product-description desc-tooltip-${eachProduct?.buyerRateContractId}`}>
                                            {eachProduct.companyProdSpec}
                                        </div>
                                        { eachProduct.companyProdSpec?.length > 60 ?
                                            <Tooltip style={{maxWidth: "450px"}} target={`.desc-tooltip-${eachProduct?.buyerRateContractId}`} content={eachProduct.companyProdSpec} position="top" autoHide />
                                            : null 
                                        }
                                    </div>
                                    { relatedMaterialBrand ? 
                                        <h6 className="mt-1 unit">
                                            <span className="erp">Brand Name:&nbsp;</span><span>{relatedMaterialBrand.brandName}</span>
                                        </h6> : null
                                    }
                                    { eachProduct.companyERPCode ? 
                                        <h6 className="mt-1 unit">
                                            <span className="erp">ERP Code:&nbsp;</span><span>{eachProduct.companyERPCode}</span>
                                        </h6> : null
                                    }
                                    <h6 className="my-1 unit">
                                        <span className="erp">Lead Time:&nbsp;</span><span>{eachProduct.leadTime} days</span>
                                    </h6>
                                    { eachProduct.companyGSTOverride ?
                                        <h6 className="my-1 unit">
                                            <span className="erp">GST(%):&nbsp;</span><span>{eachProduct.companyGSTOverride} (%)</span>
                                        </h6> : null
                                    }
                                    { eachProduct.companyERPUOM ? <h6 className="my-1 unit">
                                        <span className="erp">Unit:&nbsp;</span><span>{eachProduct.companyERPUOM}</span>
                                    </h6> : "" }
                                </div>
                                
                                <div>
                                    <div className="flex justify-content-between">
                                        <p className="my-2 price">
                                            {isListPriceVisible ? <span className="" style={{fontSize: "13px", color: "grey", textDecoration: "line-through", marginRight: "5px"}}>₹ {numberConversion(eachProduct.listPrice, "en-IN")}</span> : "" }
                                            <span className="theme-color">₹ {numberConversion(eachProduct.unitPrice, "en-IN")}</span> { discount ? <sup>{discount}% Off</sup> : "" }
                                        </p>
                                        {/*
                                            <p className="my-2 product-description unit">
                                                {eachProduct.companyERPUOM ? <>Unit: <span>{eachProduct.companyERPUOM}</span></> : ""}
                                            </p> 
                                        */}
                                    </div>

                                    { true ? 
                                        <div className="add-to-cart-box bg-white">
                                            {!relatedCartItem || (relatedCartItem && relatedCartItem.quantity === 0) ?
                                                <>
                                                    <button className="btn btn-add-cart addcart-button" style={{backgroundColor: isAddToCartDisabled && "lightgray"}} onClick={() => updateCartItems("ADD", eachProduct)} disabled={isAddToCartDisabled}>Add
                                                        <Tooltip target={`.custom-tooltip-${eachProduct?.buyerRateContractId}`} position="top" autoHide>
                                                            {tooltipStr}
                                                        </Tooltip>
                                                        <span className={`add-icon bg-light-gray ${isAddToCartDisabled ? `custom-tooltip-${eachProduct.buyerRateContractId}` : ""}`}>
                                                            <i className={isAddToCartDisabled ? 'fa fa-exclamation-triangle' : `fa fa-plus`} style={{color: isAddToCartDisabled && 'lightgray'}}></i>
                                                        </span>
                                                    </button>
                                                </>
                                                :
                                                <>
                                                    <button className="btn btn-add-cart addcart-button" disabled={isAddToCartDisabled}>Add
                                                        <span className="add-icon bg-light-gray">
                                                            <i className="fa-solid fa-plus"></i>
                                                        </span>
                                                    </button>
                                                    <div className="cart_qty qty-box">
                                                        <div className="input-group flex bg-white">
                                                            <button type="button" className="qty-left-minus bg-gray" style={{backgroundColor: isAddToCartDisabled && "lightgray"}}
                                                                data-type="minus" data-field="" onClick={() => updateCartItems("DECREASE", relatedCartItem)} >
                                                                <i className="fa fa-minus"></i>
                                                            </button>
                                                            <input
                                                                className="form-control input-number qty-input"
                                                                type="text"
                                                                name="quantity"
                                                                placeholder="Quantity"
                                                                value={relatedCartItem.quantity}
                                                                onChange={(e) => handleQuantityChange(e, relatedCartItem)}
                                                                onBlur={() => updateCartItems("SET", relatedCartItem)}
                                                            >
                                                            </input>
                                                            <button type="button" className="qty-right-plus bg-gray" style={{backgroundColor: isAddToCartDisabled && "lightgray"}}
                                                                data-type="plus" data-field="" onClick={() => updateCartItems("INCREASE", relatedCartItem)} disabled={isAddToCartDisabled}>
                                                                <i className="fa-solid fa-plus"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </div> : "" 
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default Product;